"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const antd_1 = require("antd");
const lodash_1 = require("lodash");
const useMutateWrapper_1 = require("../../hooks/useMutateWrapper");
const modelProperties_1 = require("../../services/modelProperties");
const modelPropertyTypes_1 = __importDefault(require("../../constants/modelPropertyTypes"));
const queryKeys_1 = __importDefault(require("../../constants/queryKeys"));
const validationMessages_1 = __importDefault(require("../../constants/validationMessages"));
const { Item, useForm, useWatch } = antd_1.Form;
const { Option } = antd_1.Select;
const { TEXT, RICH_TEXT, STATIC, BOOLEAN } = modelPropertyTypes_1.default;
const propertyTypesArray = [{
        propertyId: 1,
        propertyLabel: (0, lodash_1.startCase)(TEXT),
        propertyValue: TEXT,
    }, {
        propertyId: 2,
        propertyLabel: (0, lodash_1.startCase)(RICH_TEXT),
        propertyValue: RICH_TEXT,
    }, {
        propertyId: 3,
        propertyLabel: (0, lodash_1.startCase)(STATIC),
        propertyValue: STATIC,
    }, {
        propertyId: 4,
        propertyLabel: (0, lodash_1.startCase)(BOOLEAN),
        propertyValue: BOOLEAN,
    }];
const propertyTypes = propertyTypesArray.map(({ propertyId, propertyLabel, propertyValue }) => ((0, jsx_runtime_1.jsx)(Option, Object.assign({ value: propertyValue }, { children: propertyLabel }), propertyId)));
const AddModelProperty = ({ modelId, propertyNames }) => {
    const qc = (0, react_query_1.useQueryClient)();
    const [newModelPropertyForm] = useForm();
    const formPropertyTypeValue = useWatch('propertyType', newModelPropertyForm);
    const renderFormFields = () => {
        switch (formPropertyTypeValue) {
            case TEXT:
            case RICH_TEXT:
            case STATIC: {
                return ((0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'isLocalizable', valuePropName: 'checked', initialValue: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Checkbox, { children: "Localizable?" }) })));
            }
            default: return null;
        }
    };
    const onSuccessCb = () => {
        antd_1.message.success('Property created successfully!');
        newModelPropertyForm.resetFields();
        qc.invalidateQueries([queryKeys_1.default.MODELS.MODEL_DETAILS, modelId]);
    };
    const { onFormSubmit } = (0, useMutateWrapper_1.useMutateWrapper)('modelProperty', modelProperties_1.addModelProperty, { onSuccessCb });
    const handleSubmit = (values) => {
        var _a;
        onFormSubmit({ modelId, isLocalizable: (_a = values.isLocalizable) !== null && _a !== void 0 ? _a : false })(values);
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Card, Object.assign({ style: { backgroundColor: 'var(--gray-95)', maxWidth: '40rem' } }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, Object.assign({ scrollToFirstError: true, layout: 'vertical', form: newModelPropertyForm, name: 'new-model-property-form', onFinish: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'propertyType', label: 'Property Type' }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, { children: propertyTypes }) })), !!formPropertyTypeValue && ((0, jsx_runtime_1.jsxs)(antd_1.Row, Object.assign({ gutter: 6 }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Col, Object.assign({ xs: 24 }, { children: (0, jsx_runtime_1.jsx)(Item, Object.assign({ name: 'propertyName', label: 'Name', rules: [
                                    { required: true, message: validationMessages_1.default.required },
                                    { validator: (_, value) => (!(propertyNames === null || propertyNames === void 0 ? void 0 : propertyNames.includes(value))
                                            ? Promise.resolve()
                                            : Promise.reject(validationMessages_1.default.unique)),
                                    },
                                ] }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { showCount: true, maxLength: 50 }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Col, Object.assign({ xs: 24 }, { children: renderFormFields() })), (0, jsx_runtime_1.jsx)(antd_1.Button, Object.assign({ type: 'primary', htmlType: 'submit' }, { children: "Save" }))] })))] })) })));
};
exports.default = AddModelProperty;
